// extracted by mini-css-extract-plugin
module.exports = {"link":"RestSelectionItem_link__ZN0T_","address":"RestSelectionItem_address__DR4KY","name":"RestSelectionItem_name__yzI08"};